import { useContext, useMemo } from 'react'
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'

const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' }

const stripHtmlFirstLine = (body) =>
    (body || '').replace(/<[^>]*>/g, '').split('\n').find(l => l.trim()) || ''

const RecentNotesCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    const notes = useFirestoreGeneralOrderBy(
        'AdressNotes',
        'AdressID',
        adressId || '',
        'Position',
        'desc'
    )

    const recent = useMemo(
        () => (Array.isArray(notes) ? notes.slice(0, 3) : []),
        [notes]
    )

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Laatste notities</h3>
                {recent.length === 0 ? (
                    <p className="adress-dashboard-empty">Nog geen notities.</p>
                ) : (
                    <ul className="adress-dashboard-list">
                        {recent.map(note => {
                            const firstLine = stripHtmlFirstLine(note.Body)
                            return (
                                <li key={note.ID} className="adress-dashboard-list-row">
                                    <span className="adress-dashboard-list-title">
                                        {note.Title || '(zonder titel)'}
                                    </span>
                                    <span className="adress-dashboard-list-meta">
                                        {note.Timestamp
                                            ? note.Timestamp.toDate().toLocaleDateString('nl-NL', dateOptions)
                                            : ''}
                                    </span>
                                    {firstLine && (
                                        <span className="adress-dashboard-list-body">
                                            {firstLine.length > 60 ? firstLine.slice(0, 60) + '…' : firstLine}
                                        </span>
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('notes')}
                >
                    Bekijk alle notities →
                </button>
            </div>
        </div>
    )
}

export default RecentNotesCard
